import { DefaultGlobalNotFound } from "@tanstack/react-router"
import { useMemo } from "react"
import cookie from "./legal/cookie.md?raw"
import dpa from "./legal/dpa.md?raw"
import privacy from "./legal/privacy.md?raw"
import subprocessors from "./legal/subprocessors.md?raw"
import terms from "./legal/terms.md?raw"
import { Markdown } from "@/ui"

type Props = {
  slug: string
}

export default function Legal({ slug }: Props) {
  const content = useMemo(() => {
    switch (slug) {
      case "cookie":
        return cookie
      case "dpa":
        return dpa
      case "privacy":
        return privacy
      case "subprocessors":
        return subprocessors
      case "terms":
        return terms
    }
  }, [slug])

  if (!content) {
    return <DefaultGlobalNotFound />
  }

  return (
    <div className="p-8">
      <Markdown className="mx-auto">{content}</Markdown>
    </div>
  )
}
